import React from 'react'
import { CardContainer } from 'components'

const ActionCard = ({ onPressButtonService = () => {}, onPressButtonInspeksi = () => {} }) => {
  const buttonStyle =
    'flex flex-row mt-4 items-center justify-around hover:cursor-pointer rounded-md border border-solid border-primary-500 focus:outline-none space-x-1 px-3 py-3 font-medium text-md text-white bg-primary-500'

  return (
    <CardContainer>
      <div className="flex flex-col w-full items-start border border-solid border-b-1 border-x-0 border-t-0 pb-4 border-b-gray-300">
        <span className="font-semibold text-2xl text-gray-900">Action</span>
      </div>
      <div className="grid grid-cols-2 gap-6">
        <button type="button" className={buttonStyle} onClick={() => onPressButtonService()}>
          Servis Mobil
        </button>
        <button type="button" className={buttonStyle} onClick={() => onPressButtonInspeksi()}>
          Lakukan Inspeksi
        </button>
      </div>
    </CardContainer>
  )
}

export default ActionCard
